function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 16c0 8.837 7.163 16 16 16s16-7.163 16-16S24.837 0 16 0 0 7.163 0 16zm8.586-1.414a2 2 0 012.828 0L14 17.172l6.586-6.586a2 2 0 112.828 2.828l-8 8a2 2 0 01-2.828 0l-4-4a2 2 0 010-2.828z",
  fill: "currentColor"
});

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAxNkMwIDI0LjgzNjYgNy4xNjM0NCAzMiAxNiAzMkMyNC44MzY2IDMyIDMyIDI0LjgzNjYgMzIgMTZDMzIgNy4xNjM0NCAyNC44MzY2IDAgMTYgMEM3LjE2MzQ0IDAgMCA3LjE2MzQ0IDAgMTZaTTguNTg1NzkgMTQuNTg1OEM5LjM2NjgzIDEzLjgwNDcgMTAuNjMzMiAxMy44MDQ3IDExLjQxNDIgMTQuNTg1OEwxNCAxNy4xNzE2TDIwLjU4NTggMTAuNTg1OEMyMS4zNjY4IDkuODA0NzQgMjIuNjMzMiA5LjgwNDc0IDIzLjQxNDIgMTAuNTg1OEMyNC4xOTUzIDExLjM2NjggMjQuMTk1MyAxMi42MzMyIDIzLjQxNDIgMTMuNDE0MkwxNS40MTQyIDIxLjQxNDJDMTQuNjMzMiAyMi4xOTUzIDEzLjM2NjggMjIuMTk1MyAxMi41ODU4IDIxLjQxNDJMOC41ODU3OSAxNy40MTQyQzcuODA0NzQgMTYuNjMzMiA3LjgwNDc0IDE1LjM2NjggOC41ODU3OSAxNC41ODU4WiIgZmlsbD0iY3VycmVudENvbG9yIiAvPgo8L3N2Zz4K";
export { SvgCheckCircle as ReactComponent };